@let userPhotoUrl = getUserPhotoUrl();
@let userName = getUserName();
@let userOrgCode = getUserOrgCode();

<div sag-ui-avatar-base class="flex items-center">
    @if (userPhotoUrl) {
        <div
            sag-ui-avatar
            [imageUrl]="userPhotoUrl"
            [altText]="'header.user-profile.title' | translate: { userName: userName }"
        ></div>
    } @else {
        <div sag-ui-avatar></div>
    }
    @if (showData()) {
        <div>
            <p class="text-sm" sag-ui-avatar-name>{{ userName }}</p>
            <p class="text-light-textColorSecondary dark:text-dark-textColorSecondary" sag-ui-avatar-org>
                {{ userOrgCode }}
            </p>
        </div>
    }
</div>
